import axios from 'axios';

const publicationRequestApi = {
  async getSalesPerson(orderId, postalCode) {
    const params = {
      order_id: orderId,
      postal_code: postalCode
    }
    const response = await axios.get(`/api/PublicationRequest/SalesPersons`, { params });
    return response.data;
  },
  async createPublicationRequest(orderId, postalCode) {
    const response = await axios.post(`/api/PublicationRequest`, { orderId, postalCode });
    return response.data;
  }
}

export default publicationRequestApi;
